const Main = ({children}) => {
  return(
    <main className="center container"  >
      {children}
    </main>
  )
}

export default Main
  